import React, { Component } from 'react'
import T from '../../translate/T'

import * as tlcomments from '../../utils/timeline_comments'

import Button from '../../atoms/Button'
import { Col } from '../../atoms/Grid'
import Loading from '../../atoms/Loading'
import Font from '../../atoms/Font'
import Modal from '../../atoms/Modal'

import style from './style.css'

import Comment from '../../molecules/Comment'
import CreateComment from '../../molecules/CreateComment'

class Comments extends Component {
    state = {
        comments_total: 0,
        status: 'done',
        comments: [],
        total: 0,
        show: false,
        subcomments: []
    }

    componentDidMount() {
        this.handleLoadComments()
    }


    handleLoadComments() {
        this.setState({
            status: 'loading'
        })

        tlcomments.load(this.props.id, this.state.comments.length)
        .then(resp => {
            this.setState(state => ({
                comments: resp.result.reverse().concat(state.comments),
                total: resp.total,
                status: 'done',
                show: true
            }))
        })
    }

    loadSubComments(comment_key) {
        let comment = this.state.comments[comment_key]
        let comment_id = comment.comment_id

        let subcomments = this.state.subcomments
        if(!subcomments[comment_key])
        subcomments[comment_key] = {
                                    status: 'loading',
                                    data: []
                                }

        
        subcomments[comment_key].status = 'loading'

        this.setState({
            subcomments
        })

        tlcomments.loadAnswers(comment_id, subcomments[comment_key].data.length)
        .then(resp => {
            subcomments[comment_key].data = resp.result.reverse().concat(subcomments[comment_key].data)
            subcomments[comment_key].status = 'done'

            this.setState({
                subcomments
            })
        })
    }

    handleDeleteComment(key, type, ref) {
        this.setState({
            modalConfirm: true,
            toDelete: {
                type,
                key,
                ref
            }
        })
    }

    handleDeleteConfirm() {
        let type = this.state.toDelete.type
        let key = this.state.toDelete.key
        let ref = this.state.toDelete.ref
        if(type === 'comment') {
            let comment = this.state.comments[key]
            this.refs['comment'+key].style.opacity = '0.3'
            

            tlcomments.deleteComment(comment.comment_id)
            .then(resp => {
                let comments = this.state.comments
                delete comments[key]
                
                this.setState({
                    comments,
                })
            })
            
        }
        if(type === 'subcomment') {
            this.refs['subcomment'+key].style.opacity = '0.3' 
            let subcomments = this.state.subcomments
            let subcomment = subcomments[ref].data[key]
            tlcomments.deleteComment(subcomment.comment_id)
            .then(resp => {
                delete subcomments[ref].data[key]
                
                this.setState({
                    subcomments
                })
            })
        }
    }

    newComment(value, ref = null) {
        let comments = this.state.comments
        if(ref === null) {
            comments.push({
                comment: value,
                comment_id: Math.random(),
                answers: 0,
                user_avatar: this.props.user.avatar,
                user_name: this.props.user.name,
                loading: true
            })
            let key = comments.length-1

            this.setState({
                comments
            })

            tlcomments.createComment(this.props.id, value)
            .then(resp => {
                comments[key] = resp
                this.setState({
                    comments
                })
            })
            
        } else {
            let subcomments = this.state.subcomments
            subcomments[ref].data.push({
                comment: value,
                comment_id: Math.random(),
                user_avatar: this.props.user.avatar,
                user_name: this.props.user.name,
                loading: true
            })
            

            let key = subcomments[ref].data.length-1
            
            this.setState({
                subcomments
            })

            tlcomments.createComment(this.props.id, value, comments[ref].comment_id)
            .then(resp => {
                subcomments[ref].data[key] = resp
                comments[ref].answers++
                this.setState({
                    comments,
                    subcomments
                })
            })
        }
    }

    render() {
        let commnets_total = this.state.comments_total
        if(!this.props.isLogged && commnets_total === 0) return (
            <span></span>
        )

        return (
            <div>
                { this.state.show ? (
                    <div>
                        { this.state.comments.length < this.state.total && (
                            <a className={style.carregarmais} onClick={() => this.handleLoadComments()}>
                                { this.state.status === 'loading' ? T.text('c_loading') : `${T.txt('c_load_more_comments')} (${this.state.total - this.state.comments.length})` }
                            </a>
                        )}
                        { this.state.comments.map((comment, comment_key) => (
                            <div className={style.commentbox} ref={`comment${comment_key}`} key={comment.comment_id}
                            style={{
                                opacity: (comment.loading) ? '0.7' : undefined
                            }}>
                                <Comment data={{
                                    user_avatar: comment.user_avatar !== '' ? `${window.URL_ASSETS_BASE}${comment.user_avatar}` :  '',
                                    user_name: comment.user_name,
                                    user_uri: comment.user_uri,
                                    date: comment.date_time,
                                    content: comment.comment,
                                    is_admin: comment.is_admin
                                }}
                                handleDelete={() => {
                                    this.handleDeleteComment(comment_key, 'comment')
                                }}>
                                <div>                                    
                                    {(!this.state.subcomments[comment_key] || this.state.subcomments[comment_key].length === 0) && !comment.loading && (
                                        <div className={style.subcommentbtn}>
                                            <a className={style.btnlink} onClick={() => this.loadSubComments(comment_key)}>
                                                { comment.answers === 0 ? T.text('c_answer') : `${T.txt('c_answers')} (${comment.answers})` }
                                            </a>
                                        </div>
                                    )}

                                    {this.state.subcomments[comment_key] && (
                                        <div>
                                            { comment.answers - this.state.subcomments[comment_key].data.length > 0 && (
                                                <a className={style.btnlink} style={{marginBottom: '10px', display: 'block'}} onClick={() => this.loadSubComments(comment_key)}>
                                                    {this.state.subcomments[comment_key].status === 'loading' ?
                                                        T.text('c_loading')
                                                        : `${T.txt('c_load_more')} (${comment.answers - this.state.subcomments[comment_key].data.length})`
                                                    }
                                                </a>
                                            )}
                                            { this.state.subcomments[comment_key].data.map((c, k) => (
                                                <div className={style.subCommentBox} ref={`subcomment${k}`} key={`c${c.comment_id}`}
                                                style={{
                                                    opacity: (c.loading) ? '0.7' : undefined
                                                }}>
                                                    <Comment data={{
                                                        user_avatar: c.user_avatar !== '' ? `${window.URL_ASSETS_BASE}${c.user_avatar}` :  '',
                                                        user_name: c.user_name,
                                                        user_uri: comment.user_uri,
                                                        date: c.date_time,
                                                        content: c.comment,
                                                        is_admin: c.is_admin
                                                    }}
                                                    handleDelete={() => {
                                                        this.handleDeleteComment(k, 'subcomment', comment_key)
                                                    }} />
                                                </div>
                                            ))}
                                            { this.props.isLogged && (

                                                <CreateComment
                                                    handleComment={(value) => {
                                                        this.newComment(value, comment_key)
                                                    }}
                                                    avatar={this.props.user.avatar !== '' ? `${window.URL_ASSETS_BASE}${this.props.user.avatar}` :  ''}
                                                    username={this.props.user.name} />
                                            )}
                                        </div>
                                    )}
                                </div>
                                
                                </Comment>
                                
                            </div>
                        )) }
                        { this.props.isLogged && (
                            <div className={style.createComment}>
                                <CreateComment
                                    handleComment={(value) => {
                                        this.newComment(value)
                                    }}
                                    avatar={this.props.user.avatar !== '' ? `${window.URL_ASSETS_BASE}${this.props.user.avatar}` :  ''}
                                    username={this.props.user.name} />
                            </div>
                        )}
                    </div>
                ) : (
                    <div style={{ textAlign: 'center', float: 'left', width: '100%' }}>
                        <Loading size={30} />
                    </div>
                )}


                <Modal active={this.state.modalConfirm}>
                    <div style={{textAlign: 'center'}}>
                        <Col>
                            <p><Font size={30} color='#4a4a4a' weight='100'>{T.text('c_confirmation')}</Font></p>
                            <p><Font color='#4a4a4a'>{T.text('c_confirmation_delete_comment')}</Font></p>
                        </Col>
                        <Col style={{ marginTop: '20px' }}>
                            <Col size="6">
                                <Button theme='light' onClick={() => { this.setState({
                                    modalConfirm: false
                                }) }}>{T.text('c_cancel')}</Button>
                            </Col>
                            <Col size="6">
                                <Button
                                    theme='primary'
                                    onClick={() => {
                                        this.handleDeleteConfirm()

                                        this.setState({
                                            modalConfirm: false
                                        })
                                    }}>
                                    {T.text('c_confirm')}
                                </Button>
                            </Col>
                        </Col>
                    </div>
                </Modal>
            </div>
        )
    }
}

export default Comments


// WEBPACK FOOTER //
// ./src/SPRINTA/organisms/Comments/index.js